import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

interface StatItem {
  title: React.ReactNode;
  stat: React.ReactNode;
}

interface StatsSummaryCardProps {
  mainTitle: React.ReactNode;
  mainStat: React.ReactNode;
  stats?: StatItem[];
  color?: string;
  topRight?: React.ReactNode;
}

const StatsSummaryCard = ({ mainTitle, mainStat, stats, color = "lighter", topRight }: StatsSummaryCardProps) => (
  <Card className={`bg-gradient-${color}`}>
    <CardBody className="d-flex flex-column justify-content-between">
      <Row className="mb-4">
        <Col xs="auto">
          <div>
            <span className="font-weight-bold text-uppercase">{mainTitle}</span>
            <br />
            <div className="display-2 font-weight-bold">{mainStat}</div>
          </div>
        </Col>
        <Col className="d-flex align-items-start justify-content-end">{topRight}</Col>
      </Row>
      {stats?.length && (
        <Row className="align-items-end align-items-center" style={{ rowGap: "1.75rem" }}>
          {stats.map(({ title, stat }: StatItem, i: number) => (
            <Col key={i} xs={12} sm={6} lg>
              <div
                className="p-3"
                style={{ minWidth: 100, backgroundColor: "rgba(0, 0, 0, 0.05)" }}
              >
                <span className="small">{title}</span>
                <br />
                <strong>{stat}</strong>
              </div>
            </Col>
          ))}
        </Row>
      )}
    </CardBody>
  </Card>
);

export default StatsSummaryCard;
